import React from "react";
import { Box, Grid, Typography, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Sample Data
const entryData = [
  { title: "Purchase Order from Customer", to: "/NewSellEntry?flag=POC&title=PURCHASE ORDER OF CUSTOMER" },
  { title: "Production Plan Entry", to: "/Production?flag=PRODPL&title=PRODUCTION PLAN ENTRY" },
  { title: "Purchase Order to Supplier", to: "/NewSellEntry?flag=POS&title=PURCHASE ORDER TO SUPPLIER" },
  { title: "Production Entry", to: "/Production?flag=PROD&title=PRODUCTION ENTRY" },
  { title: "GRN Entry", to: "/NewSellEntry?flag=GRN&title=GRN ENTRY" },
  { title: "Packing Entry", to: "/Packing?flag=PACK&title=PACKING ENTRY" },
  { title: "Quality Check Entry", to: "/QualityCheckEntry" },
  { title: "Despatch Entry", to: "/NewSellEntry?flag=DESP&title=DESPATCH ENTRY" },
  { title: "Consumption Entry", to: "/NewSellEntry?flag=CONS&title=CONSUMPTION ENTRY" },
  { title: "Material Requision Entry", to: "/NewSellEntry?flag=MISSUE&title=MATERIAL REQUISION ENTRY" },
];

const reportData = [
  { title: "Purchase Order Customer", to: "/ReportData/PurchaseOrderRegister?flag=POC" },
  { title: "Production Plan Register", to: "/ReportData/ProductionPlanRegister?flag=PRODPL" },
  { title: "Stock Ledger", to: "/ReportData/stockLedgerr" },
  { title: "Purchase Order Supplier", to: "/ReportData/PurchaseOrderRegister?flag=POS" },
  { title: "Production Register", to: "/ReportData/ProductionRegister?flag=PROD" },
  { title: "Stock Statement", to: "/ReportData/stockStatement" },
  { title: "GRN Register", to: "/ReportData/GRNRegister?flag=GRN" },
  { title: "Packing Register", to: "/ReportData/PackingRegister?flag=PACK" },
  { title: "Batchwise Stock", to: "/ReportData/BatchStock" },
  // { title: "Performance Graph", to: "/ReportData/PERFORMANCE GRAPH" },
  { title: "Quality Check Register", to: "/ReportData/QualityCheckRegister?flag=QUAL" },
  { title: "Despatch Register", to: "/ReportData/DespatchRegister?flag=DESP" },
  { title: "Production Graph", to: "/ReportData/PRODUCTION GRAPH" },
  { title: "Consumption Register", to: "/ReportData/ConsumptionRegister?flag=CONS" },
  { title: "Material Requision Register", to: "/ReportData/MATERIAL REQUISTION REGISTER" },
  { title: "Despatch Graph", to: "/ReportData/DespatchRegister?flag=DESP" },
];

const Dashboard = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", padding: "20px" }}>
      {/* Main Content - Flexbox Layout */}
      <Grid container spacing={3}>
        {/* Transactions Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              padding: "20px",
              background: "linear-gradient(to bottom, #e8f5e9, #c8e6c9)",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Typography variant="h4" gutterBottom sx={{ color: "#2E7D32", fontWeight: "bold", textAlign:'center' }}>
              TRANSACTIONS
            </Typography>
            <Grid container spacing={3}>
              {entryData.map((entry, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Card
                    sx={{
                      height: "64px",
                      cursor: "pointer",
                      backgroundColor: "#C8E6C9",
                      borderRadius: "12px",
                      border: "1px solid #A5D6A7",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15), inset 0 2px 2px rgba(255, 255, 255, 0.2)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "0 8px 20px rgba(0, 0, 0, 0.25), inset 0 4px 4px rgba(255, 255, 255, 0.25)",
                      },
                    }}
                    onClick={() => handleNavigate(entry.to)}
                  >
                    <CardContent sx={{ textAlign: "center" }}>
                      <Typography variant="h5" sx={{ color: "#2E7D32", fontWeight: 600 }}>
                        {entry.title}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>

        {/* Reports Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              padding: "20px",
              background: "linear-gradient(to bottom, #fff3e0, #ffe0b2)",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Typography variant="h4" gutterBottom sx={{ color: "#BF360C", fontWeight: "bold", textAlign:'center' }}>
              REPORTS
            </Typography>
            <Grid container spacing={3}>
              {reportData.map((report, index) => (
                <Grid item xs={12} sm={4} key={index}>
                  <Card
                    sx={{
                      height: "64px",
                      cursor: "pointer",
                      backgroundColor: "#FFE0B2",
                      borderRadius: "8px",
                      border: "1px solid #FFCC80",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15), inset 0 2px 2px rgba(255, 255, 255, 0.2)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "0 8px 20px rgba(0, 0, 0, 0.25), inset 0 4px 4px rgba(255, 255, 255, 0.25)",
                      },
                    }}
                    onClick={() => handleNavigate(report.to)}
                  >
                    <CardContent sx={{ textAlign: "center" }}>
                      <Typography variant="h5" sx={{ color: "#BF360C", fontWeight: 600 }}>
                        {report.title}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;

